"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTotalCell = exports.StyledCell = exports.CellContainer = exports.Align = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var Align = exports.Align = /*#__PURE__*/function (Align) {
  Align["left"] = "start";
  Align["center"] = "center";
  Align["right"] = "end";
  return Align;
}({});
var CellContainer = exports.CellContainer = _styledComponents.default.div.withConfig({
  displayName: "Cellstyled__CellContainer",
  componentId: "sc-1uc5zwd-0"
})(["display:flex;flex-direction:row;align-items:center;gap:", ";"], _tokens.default.sky.sys.spacing["200"]);
var StyledCell = exports.StyledCell = _styledComponents.default.div.withConfig({
  displayName: "Cellstyled__StyledCell",
  componentId: "sc-1uc5zwd-1"
})(["width:100%;display:flex;flex-direction:row;align-items:center;justify-content:", ";gap:", ";padding:", " 0;white-space:nowrap;", ""], function (_ref) {
  var align = _ref.align;
  return align ? align : "start";
}, _tokens.default.sky.sys.spacing["200"], function (_ref2) {
  var narrow = _ref2.narrow;
  return _tokens.default.sky.sys.spacing[narrow ? "100" : "400"];
}, function (_ref3) {
  var sortable = _ref3.sortable;
  return sortable && (0, _styledComponents.css)([":hover{cursor:pointer;}"]);
});
var StyledTotalCell = exports.StyledTotalCell = (0, _styledComponents.default)(StyledCell).withConfig({
  displayName: "Cellstyled__StyledTotalCell",
  componentId: "sc-1uc5zwd-2"
})([""]);